import useDebounce from 'hooks/useDebounce';
import React, { useState, useEffect } from 'react';

const DebounceInputFiled = ({ reloadData }) => {
    const [inputValue, setInputValue] = useState('');
    const debouncedInputValue = useDebounce(inputValue, 1000);

    useEffect(() => {
        reloadData(debouncedInputValue);
    }, [debouncedInputValue]);


    return (
            <input
                type="text"
                placeholder="Search..."
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
            />
    );
};

export default DebounceInputFiled;
